import { render, staticRenderFns } from "./AdminOrder.vue?vue&type=template&id=c02068f8&lang=pug"
import script from "./AdminOrder.vue?vue&type=script&lang=js"
export * from "./AdminOrder.vue?vue&type=script&lang=js"
import style0 from "./AdminOrder.vue?vue&type=style&index=0&id=c02068f8&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports